import '/assets/styles/sections/armada-concerts.scss';
import { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';
import Slider from '/views/partials/slider';
import Eventbox from '/views/partials/eventbox-old';

// Services
import siteServices from '/services/site';

// Context
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';
// import { useLocations } from '/utilities/locations';

const SHOWCASE_KEY = 'ARMADA_CONCERTS';

const getArmadaEvents = (location) => {
	return siteServices.getShowcase(SHOWCASE_KEY, { location });
}

const ArmadaConcerts = ({ id }) => {	
	// const { selectedLocation } = useLocations();
	const{ desktop } = useBreakpoints();
	const [data, setData] = useState(null);

	useEffect(() => {
		setData(null);
		getArmadaEvents('Ankara').then((setData)).catch(() => {
			setData(undefined)
		})
	}, [])

	const events = useMemo(() => data?.events ? data.events.filter(event => event.calendar?.full_date) : [null, null, null, null], [data])

	if(data === undefined || events?.length === 0) { return null; }

	return (
		<section className="section armadaconcerts">
			<div className="armadaconcerts-wrap wrapper narrow">
				{data ?
					<h2 className="armadaconcerts-title">
						{data.icon &&
							<Icon name={data.icon} className="title-icon" />
						}
						<span className="title-text">{data.title}</span>
					</h2>
					:
					<div className="armadaconcerts-title">
						<Placeholder className="title-icon" />
						<Placeholder className="title-text" />
					</div>
				}

				<Slider
					className="armadaconcerts-slider"
					id={`${id ?? 'armadaconcerts'}-slider`}
					key={`armadaconcerts-slider-${data?.events ? 'has-data' : 'no-data'}`}
					navigation={true}
					params={{
						slidesPerView: desktop ? 4 : 2,
					}}>
					{events.map((event, nth) => (
						<Eventbox
							analytics={data?.title && {
								listId: SHOWCASE_KEY,
								listName: data.title,
							}}
							className="armadaconcerts-event"
							key={event?.id ?? nth}
							event={event} />
					))}
				</Slider>
			</div>
		</section>
	)
}

ArmadaConcerts.propTypes = {
	id: PropTypes.string,
}

export default ArmadaConcerts;